import React, { useEffect, useState } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { useUserDeductible } from "../../../context/user/DeductibleContext"
import { Steps } from "../../workflow/steps"
import { useBenefitEnrollmentFlow } from "../../../views/modal/BenefitEnrollmentFlow/BenefitEnrollmentFlowModal"
import { useCurrentUser } from "../../../context/user/UserContext"
import { waitForMinimumDelay } from "../../../views/modal/BenefitEnrollmentFlow/utils"
import { DeductibleStatus } from "carrot-api/types/DeductibleStatus"
import useInitialSetup from "../../hooks/useInitialSetup"
import { useProgressTracker } from "../../../views/modal/ProgressTracker"
import { CenteredLoadingIndicator } from "../../../views/molecules/Molecules"
import { Container } from "@carrotfertility/carotene"

const viewName = Steps.PROCESS_MEMBER_ENROLLMENT

function ProcessMemberEnrollmentStep(): JSX.Element {
  const { setProgress } = useProgressTracker()
  useStateMachine(viewName, null)
  setProgress(1, "YOUR INSURANCE COVERAGE")
  const { needsEnrollment, connectInsuranceInProgress } = useBenefitEnrollmentFlow()
  const { setNextStep } = useStateMachine()
  const { deductibleStatus } = useCurrentUser()
  const shouldInitiateEnrollment = needsEnrollment && !connectInsuranceInProgress
  const [loading, setLoading] = useState(shouldInitiateEnrollment)
  const { csdConfiguration, companyDeductibleStatus, updateUserBenefitEnrollment } = useUserDeductible()

  useInitialSetup(async () => {
    await waitForMinimumDelay(updateUserBenefitEnrollment(), 1000)
    setLoading(false)
  })

  useEffect(() => {
    if (!loading) {
      const retVal =
        deductibleStatus === DeductibleStatus.CarrotSpecificDeductible
          ? csdConfiguration
          : deductibleStatus === DeductibleStatus.ExternalDeductible
          ? "EXTERNAL"
          : "NO_DEDUCTIBLE"
      return setNextStep(Steps.PROCESS_MEMBER_ENROLLMENT, retVal)
    }
  }, [companyDeductibleStatus, viewName, loading])

  return <Container paddingTopBottom="tiny">{loading && <CenteredLoadingIndicator />}</Container>
}

export { ProcessMemberEnrollmentStep }
